<template>
  <div class="md-layout" v-if="challenge">
    <div class="md-layout-item md-size-70">
      <md-tabs class="private-challenge-tabs" md-alignment="centered">
        <md-tab id="tab-results" :md-label="$t('general.results')">
          <md-card>
              <md-card-content>
                <div class="challenge-header" style="margin-left: 20px; margin-bottom: 30px;">
                  <div class="private-challenge-title">
                    <i :class="[{ [formatActitivityIcon(myDiscipline ? myDiscipline.activityType : '')]: true }]"></i>
                    <span class="title">{{ challenge.title }}</span>
                  </div>
                  <span>{{ formatFromToDate(challenge.start, challenge.end) }}</span>
                </div>
                <div class="result-table">
                  <challenge-results-table v-if="results.length" :challenge="challenge" :data="results" :displayAvatar="true" @reloadData="loadData($event)"/>
                </div>
              </md-card-content>
          </md-card>
        </md-tab>

        <md-tab id="tab-details" :md-label="$t('challengeOverview.overviewTab')">
          <md-card>
            <template>
              <div v-if="challenge">
                <div class="challenge-header" style="margin-left: 20px; margin-bottom: 30px;">
                  <div class="left">
                    <h3>{{ challenge.title }}</h3>
                    <span>{{ formatFromToDate(challenge.start, challenge.end) }}</span>
                  </div>
                  <span class="right">
                    {{ getActivityType(challenge.activityType) }}
                  </span>
                </div>
                <md-card-media class="md-ratio-4-3">
                  <img v-if="challenge.titleImage" :src="challenge.titleImage" /><br />
                </md-card-media>
                <p v-html="this.challenge.description"></p>
              </div>
            </template>
          </md-card>
        </md-tab>
      </md-tabs>
    </div>
    <div class="md-layout-item md-size-30">
      <md-card>
        <md-card-header>
            <days-left class="days-left" :start-date="challenge.start" :end-date="challenge.end"></days-left>
        </md-card-header>
        <md-card-content>
          <stacked-users class="stacked-users" :users="participants"></stacked-users>
        </md-card-content>
        <md-card-actions>
            <div class="md-layout-item md-size-100">
            <template v-if="isMyChallenge() && isChallengeAvailable">
              <md-button class="md-success md-block" @click="toggleInviteUsersModal(true)" v-if="isChallengeAvailable">{{$t('general.invite')}}</md-button>
              <md-button class="md-info md-block" @click="toggleRemoveUserModal(true)" v-if="isChallengeAvailable">{{$t('general.invited')}}</md-button>
              <md-button class="md-danger md-block" @click="toggleDeleteChallengeModal(true)">{{$t('general.delete')}}</md-button>
            </template>
            <template v-else>
              <div v-if="userIsJoined() && isChallengeAvailable" class="md-layout buttons-container">
                <md-button class="md-danger md-block" @click="toggleLeaveChallengeModal(true)">Challenge verlassen</md-button>
              </div>
              <div v-else class="md-layout buttons-container">
                <md-button v-if="isChallengeAvailable" class="md-raised md-success md-block" @click="acceptChallenge(true)">Annehmen</md-button>
                <md-button v-if="isChallengeAvailable" class="md-raised md-block" @click="acceptChallenge(false)">Ablehnen</md-button>
              </div>
            </template>
            </div>
        </md-card-actions>
      </md-card>
    </div>

    <modal v-if="showInviteModal" class="modal-overflow" :show.sync="toggleInviteUsersModal">
      <template slot="header">
        <div class="md-layout">
          <div class="md-layout-item md-size-90">
            <span style="font-size: 20px; font-weight: 500">{{$t('friends.inviteFriends')}}</span>
          </div>
          <div class="md-layout-item md-size-10" @click="toggleInviteUsersModal(false)">
            <md-icon >close</md-icon>
          </div>
        </div>
      </template>
      <template slot="body">
        <div v-if="friendsToBeInvited.length" style="width: 100%">
          <users-list
            :showButton="true"
            :preselectedFriends="preselectedFriendsToBeInvited"
            :friends="friendsToBeInvited"
            @onCancelInvite="cancelUserInvitation($event)"
            @onSendInvite="inviteUsers($event)"
          ></users-list>
        </div>
        <div v-else style="display: flex; padding-left: 16px">
          <span class="no-friends">{{$t('friends.noFriendsAnymore')}}</span>
        </div>
      </template>
      <template slot="footer">
        <div class="md-layout" v-if="friendsToBeInvited.length">
          <md-button class="md-layout-item md-info md-size-100" @click="inviteUsersRequest">{{$t('general.save')}}</md-button>
        </div>
      </template>
    </modal>

    <modal v-if="showRemoveModal" class="modal-overflow" :show.sync="toggleRemoveUserModal">
      <template slot="header">
        <div class="md-layout">
          <div class="md-layout-item md-size-90">
            <span style="font-size: 20px; font-weight: 500">Freunde entfernen</span>
          </div>
          <div class="md-layout-item md-size-10" @click="toggleRemoveUserModal(false)">
            <md-icon >close</md-icon>
          </div>
        </div>
      </template>
      <template slot="body" >
        <div v-if="friendsToBeRemoved.length" style="width: 100%">
          <users-list
              :showButton="true"
              :preselectedFriends="preselectedFriendsToBeRemoved"
              :friends="friendsToBeRemoved"
              :acceptButtonText="'entfernen'"
              :cancelButtonText="'abbrechen'"
              @onCancelInvite="cancelUserRemove($event)"
              @onSendInvite="removeUsers($event)"
          ></users-list>
        </div>
        <div v-else style="display: flex; padding-left: 16px">
          <span class="no-friends">Keine Teilnehmer</span>
        </div>
      </template>
      <template slot="footer">
        <div class="md-layout" v-if="friendsToBeRemoved.length">
          <md-button class="md-layout-item md-info md-size-100" @click="removeUserRequest">Save</md-button>
        </div>
      </template>
    </modal>

    <modal v-if="showDeleteChallengeModal" class="delete-challenge-container">
      <template slot="header">
        <span>Delete Challenge</span>
      </template>
      <template slot="body">
        <p>Are you sure you want to delete this challenge?</p>
      </template>
      <template slot="footer">
        <md-button class="md-simple" @click="toggleDeleteChallengeModal(false)">Nein</md-button>
        <md-button class="md-success md-simple" @click="deleteChallenge()">Ja</md-button>
      </template>
    </modal>

    <modal v-if="showLeaveChallengeModal" class="delete-challenge-container">
      <template slot="header">
        <span>Leave Challenge</span>
      </template>
      <template slot="body">
        <p>Are you sure you want to leave this challenge?</p>
      </template>
      <template slot="footer">
        <md-button class="md-simple" @click="toggleLeaveChallengeModal(false)">Nein</md-button>
        <md-button class="md-success md-simple" @click="leaveChallenge()">Ja</md-button>
      </template>
    </modal>
  </div>
  <div v-else>
    LOADING
  </div>
</template>

<script>
import ChallengeResultsTable from "sports4me-web_components/atomic-design/molecules/challenge-results-table";
import datetime from "@/utils/datetime";
import activity from "@/utils/activity";
import { mapState } from "vuex";
import Modal from '../../components/Modal';
import UsersList from 'sports4me-web_components/atomic-design/molecules/users-list';
import DaysLeft from 'sports4me-web_components/atomic-design/atoms/days-left';
import StackedUsers from 'sports4me-web_components/atomic-design/molecules/stacked-users';

export default {
  components: {
    ChallengeResultsTable,
    Modal,
    UsersList,
    DaysLeft,
    StackedUsers,
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    isChallengeAvailable() {
      const endDate = new Date(this.challenge.end)
      return (endDate > new Date());
    },
  },
  data() {
    return {
      challengeId: this.$route.params.id,
      challenge: undefined,
      results: [],
      pTotal: 1,
      showInviteModal: false,
      showRemoveModal: false,
      showDeleteChallengeModal: false,
      showLeaveChallengeModal: false,
      participants: [],
      friendsToBeInvited: [],
      friendsToBeRemoved: [],
      preselectedFriendsToBeInvited: [],
      preselectedFriendsToBeRemoved: [],
      myData: null,
      myDiscipline: null,
    }
  },
  mounted() {
    this.getChallenge();
  },
  methods: {
    ...datetime,
    ...activity,
    getFriends() {
      this.$store.dispatch("loadFriends")
          .then(res => {
            if (this.challenge) {
              const tempArray = this.challenge.invited.concat(this.challenge.joined);
              this.participants = this.challenge.joined.map(j => {
                return {
                  id: j.userId,
                  displayName: j.userDisplayName,
                  image: j.userImage,
                }
              })
              this.friendsToBeInvited = res.filter(f => tempArray.map(u => u.userId).indexOf(f._id) === -1 );
              this.friendsToBeRemoved = res.filter(f => this.challenge.joined.map(u => u.userId).indexOf(f._id) !== -1 );
            } else {
              this.friendsToBeInvited = res;
              this.friendsToBeRemoved = res;
            }
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          })
    },
    loadMyData() {
      this.$store
          .dispatch("loadMyLeaderboard", {
            challengeId: this.challenge._id
          })
          .then(res => {
              this.myData = res
              if (this.challenge && this.challenge.disciplines) {
                this.myDiscipline = this.challenge.disciplines.find(d => d.name === this.myData.discipline);
              }
          })
    },
    // Toggle Modals
    toggleDeleteChallengeModal(shouldShowModal) {
      this.showDeleteChallengeModal = shouldShowModal;
    },
    toggleRemoveUserModal(shouldShowModal) {
      this.showRemoveModal = shouldShowModal;
    },
    toggleInviteUsersModal(showInviteUsersModal) {
      this.showInviteModal = showInviteUsersModal
    },
    toggleLeaveChallengeModal(showLeaveChallengeModal) {
      this.showLeaveChallengeModal = showLeaveChallengeModal
    },
    // Invite User
    cancelUserInvitation(id) {
      this.preselectedFriendsToBeInvited = this.preselectedFriendsToBeInvited.filter(f => f !== id);
    },
    inviteUsers(id) {
      this.preselectedFriendsToBeInvited.push(id)
    },
    inviteUsersRequest() {
      if (this.challenge && this.challenge._id) {
        const url =`/rest/challenge/${this.challenge._id}/invite/friends`;
        const toBeInvited = this.friendsToBeInvited.filter(f => this.preselectedFriendsToBeInvited.includes(f._id));
        const data = {
          invited: toBeInvited.map(t => {
            return {
              userId: t._id,
              userDisplayName: t.displayName,
              userImage: t.image,
            }
          }),
        };
        this.$store
            .dispatch("postAPI", {
              url: url,
              method: "PUT",
              data: data
            })
            .then(res => {
              this.getFriends();
              this.toggleInviteUsersModal(false);
              this.$notify({
                timeout: 5000,
                message: "Einladung erfolgreich gesendet",
                type: "success",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                type: "error",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            });
      }
    },
    // Remove User
    removeUsers(id) {
      this.preselectedFriendsToBeRemoved.push(id);
    },
    cancelUserRemove(id) {
      this.preselectedFriendsToBeRemoved = this.preselectedFriendsToBeRemoved.filter(f => f !== id);
    },
    removeUserRequest() {
      if (this.challenge && this.challenge._id) {
        const url =`/rest/challenge/${this.challenge._id}/reject/friends`;
        const toBeRemoved = this.friendsToBeRemoved.filter(f => this.preselectedFriendsToBeRemoved.includes(f._id));
        const data = {
          reject: toBeRemoved.map(t => {
            return {
              userId: t._id,
              userDisplayName: t.displayName,
              userImage: t.image,
            }
          }),
        };
        this.$store
            .dispatch("postAPI", {
              url: url,
              method: "PUT",
              data: data
            })
            .then(res => {
              this.getFriends();
              this.getChallenge();
              this.toggleRemoveUserModal(false)
              this.$notify({
                timeout: 5000,
                message: "Benutzer erfolgreich entfernt",
                type: "success",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                type: "error",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            });
      }
    },

    deleteChallenge() {
      this.$store
          .dispatch("queryAPI", { url: "/rest/challenge/" + this.challengeId,  method: "DELETE" })
          .then(res => {
            this.$router.push('/Challenges');
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          });
    },
    leaveChallenge() {
      if (this.challenge && this.challenge._id) {
        const url =`/rest/challenge/${this.challenge._id}/reject/me`;

        this.$store
            .dispatch("postAPI", {
              url: url,
              method: "PUT",
              data: null
            })
            .then(res => {
              this.getChallenge();
              this.toggleLeaveChallengeModal(false);
              this.$notify({
                timeout: 5000,
                message: "Challenge erfolgreich beendet",
                type: "success",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                type: "error",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            });
      }
    },
    acceptChallenge(hasAccepted) {
      if (this.challenge && this.challenge._id) {
        const url = hasAccepted
            ? `/rest/challenge/${this.challenge._id}/joined/me`
            : `/rest/challenge/${this.challenge._id}/reject/me`;

        this.$store
            .dispatch("postAPI", {
              url: url,
              method: "PUT",
              data: null
            })
            .then(res => {
              this.getChallenge();
              if (hasAccepted) {
                this.$notify({
                  timeout: 5000,
                  message: "Sie haben sich der Challenge angeschlossen",
                  type: "success",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                });
              } else {
                this.$router.push('../../');
              }
            })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                type: "error",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            });
      }
    },

    getChallenge() {
      this.$store
      .dispatch("queryAPI", {url: "/rest/challenge/" + this.challengeId + "?v=1"})
      .then(res => {
        this.challenge = res;
        this.loadData();
        this.loadChallengeResultsCount();
        this.getFriends();
        this.loadMyData();

        this.finished = ((new Date(this.challenge.end)) < (new Date()));
      })
      .catch(err => {
        this.$notify({
          timeout: 5000,
          message: err.message,
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
      });
    },
    loadData(filters) {
      if(!filters) {
        filters = {
          paginationPerPage: 5,
          currentPage: 1,
          pTotal: this.pTotal,
          searchQuery: ""
        }
      }
      this.$store
        .dispatch("loadLeaderboard", {
          challengeId: this.challengeId,
          // sort: this.currentSort,
          // sortOrder: this.currentSortOrder,
          search: filters.searchQuery,
          // filter: this.filterChallenge,
          page: filters.currentPage,
          pageSize: filters.paginationPerPage // pagination.perPage
        })
        .then(res => {
          this.results = res;
          // TODO don't hardcode access to data fields
          res.forEach(item => {
            item.data.name = (
              (item.data.vorname || "") +
              " " +
              (item.data.nachname || "")
            ).trim();
          });
        });
    },
    loadChallengeResultsCount() {
      this.$store
        .dispatch("loadChallengeResultsCount", {
          challengeId: this.challengeId
        })
        .then(res => {
          this.pTotal = res.count || 1;
        });
    },
    isMyChallenge() {
      return this.challenge && this.user && this.challenge.creatorId == this.user._id;
    },
    userIsJoined() {
      return this.challenge && this.user && this.challenge.joined.length && this.challenge.joined.find(u => u.userId == this.user._id );
    }
  }
}
</script>

<style lang="scss">
.md-tabs-content table thead {
  display: contents;
}

.md-tabs-navigation {
  box-shadow: none;
}
.private-challenge-tabs .md-tabs-content {
  background: #eeeeee !important;
}

.table-results-content {
  padding: 0 !important;
}
.table-results-content .result-table {
  padding: 0 16px;
}
.private-challenge-tabs .md-content {
  &.md-theme-default {
    height: 100%;
  }

}
 .md-tab-nav-button .md-button-content {
    //color: red;
  }

 .private-challenge-tabs {
   .private-challenge-title {
     display: flex;
     margin-top: 12px;
     padding: 8px 0;
     .title {
       font-size: 34px;
       font-weight: 500;
       margin-left: 8px;
     }
     i {
       color: #DF263B;
       width: 24px;
       height: 24px;
       font-size: 14px;
       padding: 4px;
       background: rgba(223, 38, 59, 0.12);
     }
   }

   .md-tab-nav-button {
     width: 40%;
     &.md-active {
       border-bottom: 2px solid #DF263B;
     }
     .md-button-content {
       color: #DF263B;
       font-size: 14px;
       font-weight: 500;
     }
   }

 }
.delete-challenge-container .modal-container {
  max-width: fit-content !important;
}

.challenge-right-side {
  justify-content: center;
  padding: 8px 0;
  .days-left {
    margin-bottom: 12px;
  }
  .buttons-container {
    display: flex;
    justify-content: center;
  }
}

.private-stacked-users {
  .stacked-users {
    justify-content: end !important;
  }
}
.no-friends {
  font-size: 20px;
  font-weight: 400;
}
.modal-overflow {
  .modal-container {
    max-height: calc(100vh - 60px);
    position: relative;
    display: flex;
    flex-direction: column;
    .modal-body {
      overflow-y: auto;
    }
  }
}
</style>
